<template>
  <div class="wages wrapper shadow level-setting">
    <div class="operation">
      <div class="left">
        <div class="main-title">入保企业设置</div>
      </div>
    </div>
    <div class="level-pane">
      <ul>
        <li v-for="(item, index) in levelList" :key="index">
            <div class="name">
                <span>
              <el-input
                  v-model="item.name"
                  placeholder="企业名称"
                  size="large"
              >
            </el-input>
              </span>
            </div>
          <div class="base-pay">
            <el-button
              class="del-btn"
              type="danger"
              :icon="Delete"
              @click="delClick(index)"
            ></el-button>
          </div>
        </li>
      </ul>
      <div class="operate-btn">
        <el-button
          type="warning"
          @click="addClick"
          class="main-btn main-btn-warning add-btn"
          >添加企业</el-button
        >
        <el-button
          type="primary"
          @click="saveClick"
          class="main-btn main-btn-primary save-btn"
          >保存设置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import { Delete } from "@element-plus/icons-vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {fetchList, batchSave } from "@/api/insureCompany";

onMounted(() => {
    getList();
});

const levelList = ref([]);

const getList = () => {
    fetchList().then((res) => {
        levelList.value = res.data.list
    });
}

// 添加一行
const addClick = () => {
  levelList.value.push({
      id: '',
      name: '',
  });
};
// 删除一行
const delClick = (index) => {
  levelList.value.splice(index, 1);
};
// 保存设置
const saveClick = () => {
    let list = levelList.value
    let check = true
    list.forEach(e => {
        if (!e.name) {
            check = false
        }
    })
    if (!check) {
        ElMessage({
            type: "error",
            message: "请将数据填写完整！",
        });
        return
    }
  ElMessageBox.confirm("确定要保存设置吗?", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
        batchSave({ list: levelList.value }).then(() => {
            getList()
            ElMessage({
                type: "success",
                message: "保存成功！",
            });
        })
    })
    .catch(() => {});
};
</script>

<style lang="scss" scoped>
.level-setting {
  .level-pane {
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 48%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #e0f2ff;
        padding: 5px 10px;
        margin: 0 0 10px 0;
        .name {
          flex: 1;
          margin-right: 10px;
          span {
            font-size: 18px;
            font-weight: bold;
            color: $main-color;
          }
        }
        .base-pay {
          display: flex;
          align-items: center;
          .del-btn {
            margin: 0;
            padding: 8px 10px;
            font-size: 18px;
          }
        }
      }
    }
  }
  .operate-btn {
    margin: 10vh auto 0;
    width: fit-content;
    .save-btn {
      width: 240px;
    }
  }
}
@media (max-width:1200px) {
		.level-pane{
			li{
				width: 100%!important;
			}
		}
	}
</style>
